import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationExtractResourceContentArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractResourceContent(
    $customerId: ID!
    $workspaceId: ID!
    $input: ResourceDetailsInput!
    $withImages: Boolean
  ) {
    extractResourceContent(
      customerId: $customerId
      workspaceId: $workspaceId
      input: $input
      withImages: $withImages
    ) {
      id
      status
    }
  }
`;

type Variables = BackendMutationExtractResourceContentArgs;
type Result = Pick<BackendJob, 'id' | 'status'>;

export const extractResourceContent = async ({ withImages = false, ...rest }: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { ...rest, withImages },
  });
  return getSingleProp<Result>(result.data);
};
